// ******************************** //
// ******* Global Contacts ******** //
// ******************************** //

export const GLOBAL_CONTACTS = {
  LOAD: 'GLOBAL_CONTACTS_LOAD',
  SUCCESS: 'GLOBAL_CONTACTS_SUCCESS',
  FAIL: 'GLOBAL_CONTACTS_FAIL',
  RESET: 'GLOBAL_CONTACTS_RESET',
  SORT_LIST: 'GLOBAL_CONTACTS_SORT_LIST',
  RESET_SORT: 'GLOBAL_CONTACTS_RESET_SORT',
  STAGE_UPDATE: 'GLOBAL_CONTACTS_STAGE_UPDATE',
  REMOVE_ALL_LIST: 'GLOBAL_CONTACTS_REMOVE_ALL_LIST',
};

export const GLOBAL_CONTACTS_SEARCH = {
  LOAD: 'GLOBAL_CONTACTS_SEARCH_LOAD',
  SUCCESS: 'GLOBAL_CONTACTS_SEARCH_SUCCESS',
  FAIL: 'GLOBAL_CONTACTS_SEARCH_FAIL',
  RESET: 'GLOBAL_CONTACTS_SEARCH_RESET',
  SET_SEARCH_TERM: 'GLOBAL_CONTACTS_SEARCH_SET_SEARCH_TERM',
  SORT_LIST: 'GLOBAL_CONTACTS_SEARCH_SORT_LIST',
  STAGE_UPDATE: 'GLOBAL_CONTACTS_SEARCH_STAGE_UPDATE',
};

export const GLOBAL_CONTACTS_ADD_NEW_CONTACTS = {
  LOAD: 'GLOBAL_CONTACTS_ADD_NEW_CONTACTS_LOAD',
  SUCCESS: 'GLOBAL_CONTACTS_ADD_NEW_CONTACTS_SUCCESS',
  FAIL: 'GLOBAL_CONTACTS_ADD_NEW_CONTACTS_FAIL',
  RESET: 'GLOBAL_CONTACTS_ADD_NEW_CONTACTS_RESET',
  RESET_NEW_CONTACT_ADDED: 'GLOBAL_CONTACTS_ADD_NEW_CONTACTS_RESET_NEW_CONTACT_ADDED',
  SET_RECENTLY_ADDED_CONTACTS: 'GLOBAL_CONTACTS_ADD_NEW_CONTACTS_SET_RECENTLY_ADDED_CONTACTS',
};

export const GLOBAL_CONTACTS_DELETE_CONTACTS = {
  LOAD: 'GLOBAL_CONTACTS_DELETE_CONTACTS_LOAD',
  SUCCESS: 'GLOBAL_CONTACTS_DELETE_CONTACTS_SUCCESS',
  FAIL: 'GLOBAL_CONTACTS_DELETE_CONTACTS_FAIL',
  RESET: 'GLOBAL_CONTACTS_DELETE_CONTACTS_RESET',
};

export const GLOBAL_CONTACTS_UPDATE_CONTACTS = {
  LOAD: 'GLOBAL_CONTACTS_UPDATE_CONTACTS_LOAD',
  SUCCESS: 'GLOBAL_CONTACTS_UPDATE_CONTACTS_SUCCESS',
  FAIL: 'GLOBAL_CONTACTS_UPDATE_CONTACTS_FAIL',
  RESET: 'GLOBAL_CONTACTS_UPDATE_CONTACTS_RESET',
};

export const GLOBAL_CONTACTS_ADD_CONTACTS_TO_LIST = {
  LOAD: 'GLOBAL_CONTACTS_ADD_CONTACTS_TO_LIST_LOAD',
  SUCCESS: 'GLOBAL_CONTACTS_ADD_CONTACTS_TO_LIST_SUCCESS',
  FAIL: 'GLOBAL_CONTACTS_ADD_CONTACTS_TO_LIST_FAIL',
  RESET: 'GLOBAL_CONTACTS_ADD_CONTACTS_TO_LIST_RESET',
};

export const GLOBAL_CONTACTS_REMOVED_FROM_LIST = {
  REMOVE: 'GLOBAL_CONTACTS_REMOVED_FROM_LIST_REMOVE',
};

export const GLOBAL_CONTACTS_ADD_TO_LIST_MODE = {
  ADD_MODE: 'GLOBAL_CONTACTS_ADD_TO_LIST_ADD_MODE',
};

export const CONTACTS_EDIT_SIDE_PANEL = {
  OPEN: 'CONTACTS_EDIT_SIDE_PANEL_OPEN',
  CLOSE: 'CONTACTS_EDIT_SIDE_PANEL_CLOSE',
};

export const GLOBAL_CONTACTS_SELECTION = {
  SET: 'GLOBAL_CONTACTS_SELECTION_SET',
  RESET: 'GLOBAL_CONTACTS_SELECTION_RESET',
};

// ******************************** //
// ******* Contacts Filters ******* //
// ******************************** //

export const GLOBAL_CONTACTS_FILTERS = {
  LOAD: 'GLOBAL_CONTACTS_FILTERS_LOAD',
  SUCCESS: 'GLOBAL_CONTACTS_FILTERS_SUCCESS',
  FAIL: 'GLOBAL_CONTACTS_FILTERS_FAIL',
  RESET: 'GLOBAL_CONTACTS_FILTERS_RESET',
  SELECT_FILTER: 'GLOBAL_CONTACTS_FILTERS_SELECT_FILTER',
  RESET_SELECTION: 'GLOBAL_CONTACTS_FILTERS_RESET_SELECTION',
  APPLY_FILTERS: 'GLOBAL_CONTACTS_FILTERS_APPLY_FILTERS',
};

export const GLOBAL_CONTACTS_FILTERS_SEARCH = {
  LOAD: 'GLOBAL_CONTACTS_FILTERS_SEARCH_LOAD',
  SUCCESS: 'GLOBAL_CONTACTS_FILTERS_SEARCH_SUCCESS',
  FAIL: 'GLOBAL_CONTACTS_FILTERS_SEARCH_FAIL',
  RESET: 'GLOBAL_CONTACTS_FILTERS_SEARCH_RESET',
  SET_SEARCH_TERM: 'GLOBAL_CONTACTS_FILTERS_SEARCH_SET_SEARCH_TERM',
  SELECT_FILTER: 'GLOBAL_CONTACTS_FILTERS_SEARCH_SELECT_FILTER',
  RESET_SELECTION: 'GLOBAL_CONTACTS_FILTERS_SEARCH_RESET_SELECTION',
};

export const LIST_CONTACTS_FILTERS = {
  LOAD: 'LIST_CONTACTS_FILTERS_LOAD',
  SUCCESS: 'LIST_CONTACTS_FILTERS_SUCCESS',
  FAIL: 'LIST_CONTACTS_FILTERS_FAIL',
  RESET: 'LIST_CONTACTS_FILTERS_RESET',
  SELECT_FILTER: 'LIST_CONTACTS_FILTERS_SELECT_FILTER',
  RESET_SELECTION: 'LIST_CONTACTS_FILTERS_RESET_SELECTION',
  APPLY_FILTERS: 'LIST_CONTACTS_FILTERS_APPLY_FILTERS',
  RESET_ALL: 'LIST_CONTACTS_FILTERS_RESET_ALL',
  SET_LIST_ID: 'LIST_CONTACTS_FILTERS_SET_LIST_ID',
};

export const LIST_CONTACTS_FILTERS_SEARCH = {
  LOAD: 'LIST_CONTACTS_FILTERS_SEARCH_LOAD',
  SUCCESS: 'LIST_CONTACTS_FILTERS_SEARCH_SUCCESS',
  FAIL: 'LIST_CONTACTS_FILTERS_SEARCH_FAIL',
  RESET: 'LIST_CONTACTS_FILTERS_SEARCH_RESET',
  SET_SEARCH_TERM: 'LIST_CONTACTS_FILTERS_SEARCH_SET_SEARCH_TERM',
  SELECT_FILTER: 'LIST_CONTACTS_FILTERS_SEARCH_SELECT_FILTER',
  RESET_SELECTION: 'LIST_CONTACTS_FILTERS_SEARCH_RESET_SELECTION',
};

// ******************************** //
// ******** List Contacts ********* //
// ******************************** //

export const LIST_CONTACTS = {
  LOAD: 'LIST_CONTACT_LOAD',
  SUCCESS: 'LIST_CONTACT_SUCCESS',
  FAIL: 'LIST_CONTACT_FAIL',
  ERROR: 'LIST_CONTACT_ERROR',
  DATA_RESET: 'LIST_CONTACT_DATA_RESET',
  RESET: 'LIST_CONTACT_RESET',
  RELOAD: 'LIST_CONTACTS_RELOAD',
  SET_LIST_ID: 'SET_LIST_ID',
  OPEN_LIST_LOADING: 'LIST_CONTACTS_OPEN_LIST_LOADING',
  SORT_LIST: 'LIST_CONTACTS_SORT_LIST',
  RESET_SORT: 'LIST_CONTACTS_RESET_SORT',
  PREV_NAME_RESET: 'LIST_CONTACTS_PREV_NAME_RESET',
  PREV_NAME_SET: 'LIST_CONTACTS_PREV_NAME_SET',
  UPDATE_SCHEDULED_EMAIL_LIST: 'LIST_CONTACTS_UPDATE_SCHEDULED_EMAIL_LIST',
  RESET_SCHEDULED_EMAIL_LIST: 'LIST_CONTACTS_RESET_SCHEDULED_EMAIL_LIST',
  UPDATE_SCHEDULED_MODAL_OPEN: 'LIST_CONTACTS_UPDATE_SCHEDULED_MODAL_OPEN',
  STAGE_UPDATE: 'LIST_CONTACTS_STAGE_UPDATE',
};

export const LIST_CONTACTS_SEARCH = {
  LOAD: 'LIST_CONTACT_SEARCH_LOAD',
  SUCCESS: 'LIST_CONTACT_SEARCH_SUCCESS',
  FAIL: 'LIST_CONTACT_SEARCH_FAIL',
  RESET: 'LIST_CONTACT_SEARCH_RESET',
  SET_SEARCH_TERM: 'LIST_CONTACT_SET_SEARCH_TERM',
  REMOVE_SEARCH_TERM: 'LIST_CONTACTS_SEARCH_REMOVE_SEARCH_TERM',
  SORT_LIST: 'LIST_CONTACTS_SEARCH_SORT_LIST',
  STAGE_UPDATE: 'LIST_CONTACTS_SEARCH_STAGE_UPDATE',
};

export const LIST_CONTACTS_DELETE_CONTACTS = {
  LOAD: 'LIST_CONTACTS_DELETE_CONTACTS_LOADING',
  SUCCESS: 'LIST_CONTACTS_DELETE_CONTACTS_SUCCESS',
  FAIL: 'LIST_CONTACTS_DELETE_CONTACTS_FAIL',
  ERROR: 'LIST_CONTACTS_DELETE_CONTACTS_ERROR',
};

export const LIST_CONTACTS_EDIT_LISTNAME = {
  LOAD: 'LIST_CONTACTS_EDIT_LISTNAME_LOADING',
  SUCCESS: 'LIST_CONTACTS_EDIT_LISTNAME_SUCCESS',
  FAIL: 'LIST_CONTACTS_EDIT_LISTNAME_FAIL',
  ERROR: 'LIST_CONTACTS_EDIT_LISTNAME_ERROR',
};

export const LIST_CONTACTS_SELECTION = {
  SELECT_CONTACT: 'LIST_CONTACTS_SELECTION_SELECT_CONTACT',
  ALL: 'LIST_CONTACTS_SELECTION_ALL',
  CLEAR: 'LIST_CONTACTS_SELECTION_CLEAR',
};

export const LIST_CONTACTS_ADD_NEW_CONTACT = {
  LOAD: 'LIST_CONTACTS_ADD_NEW_CONTACT_LOAD',
  SUCCESS: 'LIST_CONTACTS_ADD_NEW_CONTACT_SUCCESS',
  FAIL: 'LIST_CONTACTS_ADD_NEW_CONTACT_FAIL',
  RESET: 'LIST_CONTACTS_ADD_NEW_CONTACT_RESET',
};

export const LIST_CONTACTS_UPDATE_CONTACT = {
  LOAD: 'LIST_CONTACTS_UPDATE_CONTACT_LOAD',
  SUCCESS: 'LIST_CONTACTS_UPDATE_CONTACT_SUCCESS',
  FAIL: 'LIST_CONTACTS_UPDATE_CONTACT_FAIL',
  RESET: 'LIST_CONTACTS_UPDATE_CONTACT_RESET',
};

export const LIST_CONTACTS_ADD_TO_LIST = {
  ADD: 'LIST_CONTACTS_ADD_TO_LIST_ADD',
  REMOVE: 'LIST_CONTACTS_ADD_TO_LIST_REMOVE',
  UPDATE_TOTAL_COUNT: 'LIST_CONTACTS_ADD_TO_LIST_UPDATE_TOTAL_COUNT',
};

// ******************************** //
// ******** Lists Listing ********* //
// ******************************** //

export const CLONE_LIST = {
  LOAD: 'CLONE_LIST_LOAD',
  SUCCESS: 'CLONE_LIST_SUCCESS',
  FAIL: 'CLONE_LIST_FAIL',
};
